var Feature = /*#__PURE__*/function (Feature) {
  Feature["PayBills"] = "Pay Bills";
  Feature["BillPay"] = "Bill Pay";
  Feature["DoMoreWithYourMoney"] = "Do More With Your Money";
  return Feature;
}(Feature || {});
var Page = /*#__PURE__*/function (Page) {
  Page["NPlusOneAuthorization"] = "N Plus One Authorization";
  Page["PayBills"] = "Pay Bills";
  Page["StoredBalance"] = "Stored Balance";
  return Page;
}(Page || {});
var Action = /*#__PURE__*/function (Action) {
  Action["Click"] = "Click";
  Action["View"] = "View";
  return Action;
}(Action || {});
var Target = /*#__PURE__*/function (Target) {
  Target["BillPay"] = "Bill Pay";
  Target["CopyAccountNumber"] = "Copy Account Number";
  Target["CopyCardPAN"] = "Copy Card PAN";
  Target["CopyRoutingNumber"] = "Copy Routing Number";
  Target["DoMoreWithYourMoney"] = "Do More With Your Money";
  Target["PayBills"] = "Pay Bills";
  Target["ShowAccountDetails"] = "Show Account Details";
  Target["StatementsAndDocuments"] = "Statements And Documents";
  Target["ToggleCard"] = "Toggle Card";
  Target["ToggleDirectDepositAccount"] = "Toggle Direct Deposit Account";
  Target["ToggleUploadABill"] = "Toggle Upload A Bill";
  Target["BillTypeSelection"] = "Bill Type Selection";
  Target["ToggleWireTransfer"] = "Toggle Wire Transfer";
  Target["UploadABill"] = "Upload A Bill";
  Target["JoinTheWaitlist"] = "Join The Waitlist";
  Target["ResendCode"] = "Resend Code";
  return Target;
}(Target || {}); // NOTE(steckel): For use with DataAPI#track
export const event = (feature, page, action, target, props = {}) => [`${action} ${feature}`, {
  applet: 'Banking',
  feature,
  page,
  target,
  ...props
}];
export let DoMoreWithYourMoney;
(function (_DoMoreWithYourMoney) {
  const VIEW_DO_MORE_WITH_YOUR_MONEY = _DoMoreWithYourMoney.VIEW_DO_MORE_WITH_YOUR_MONEY = event(Feature.DoMoreWithYourMoney, Page.StoredBalance, Action.View, Target.DoMoreWithYourMoney);
  const CLICK_STATEMENTS_AND_DOCUMENTS = _DoMoreWithYourMoney.CLICK_STATEMENTS_AND_DOCUMENTS = event(Feature.DoMoreWithYourMoney, Page.StoredBalance, Action.Click, Target.StatementsAndDocuments);
  const CLICK_BILL_PAY = _DoMoreWithYourMoney.CLICK_BILL_PAY = event(Feature.DoMoreWithYourMoney, Page.StoredBalance, Action.Click, Target.BillPay);
  const TOGGLE_ACCOUNT_DETAILS = _DoMoreWithYourMoney.TOGGLE_ACCOUNT_DETAILS = event(Feature.DoMoreWithYourMoney, Page.StoredBalance, Action.Click, Target.ShowAccountDetails);
})(DoMoreWithYourMoney || (DoMoreWithYourMoney = {}));
export let PayBillsModal;
(function (_PayBillsModal) {
  const clickBillTypeSelection = _PayBillsModal.clickBillTypeSelection = bill_type => event(Feature.BillPay, Page.PayBills, Action.Click, Target.BillTypeSelection, {
    bill_type
  });
})(PayBillsModal || (PayBillsModal = {}));
export let BillPayHelp;
(function (_BillPayHelp) {
  const viewBillPayHelp = _BillPayHelp.viewBillPayHelp = details => event(Feature.PayBills, Page.PayBills, Action.View, undefined, details);
  const clickToggleCardAccordion = _BillPayHelp.clickToggleCardAccordion = toggle => event(Feature.PayBills, Page.PayBills, Action.Click, Target.ToggleCard, {
    toggle
  });
  const clickToggleDirectDepositAccountAccordion = _BillPayHelp.clickToggleDirectDepositAccountAccordion = toggle => event(Feature.PayBills, Page.PayBills, Action.Click, Target.ToggleDirectDepositAccount, {
    toggle
  });
  const clickToggleBillPayAccordion = _BillPayHelp.clickToggleBillPayAccordion = toggle => event(Feature.PayBills, Page.PayBills, Action.Click, Target.ToggleUploadABill, {
    toggle
  });
  const clickToggleWireTransferAccordion = _BillPayHelp.clickToggleWireTransferAccordion = toggle => event(Feature.PayBills, Page.PayBills, Action.Click, Target.ToggleWireTransfer, {
    toggle
  });
  const CLICK_UPLOAD_BILL = _BillPayHelp.CLICK_UPLOAD_BILL = event(Feature.PayBills, Page.PayBills, Action.Click, Target.UploadABill);
  const CLICK_JOIN_THE_WAITLIST = _BillPayHelp.CLICK_JOIN_THE_WAITLIST = event(Feature.PayBills, Page.PayBills, Action.Click, Target.JoinTheWaitlist);
  const CLICK_RESEND_CODE = _BillPayHelp.CLICK_RESEND_CODE = event(Feature.PayBills, Page.NPlusOneAuthorization, Action.Click, Target.ResendCode);
})(BillPayHelp || (BillPayHelp = {}));